export default "__VITE_ASSET__B1u1fIxA__"